// VIN OTA组件共享配置数据
export default {
  // 组件标题和标签
  textObj: {
    formTitle: '车辆OTA升级查询',
    vinLabel: '车架号后6位',
    modelLabel: '车型名称'
  },
}

export const DEFAULT_FAIL_MESSAGE='未查询到车辆OTA升级信息'